export default __webpack_public_path__ + "static/media/fad-modsawup.bc893740.svg";